import {
  isProd,
} from '@RootCommon/utils'

export const DEFAULT_FILTER_VALUE = -999
export const ALL_FILTER_VALUE = -1

/** 评论列表和评分卡共用的日期快捷项；默认值由页面初始化为 prev1（昨天）。 */
export const dateBtnList = [
  { label: 'Yesterday', value: 'prev1', key: 'review_date_yesterday' },
  { label: 'Past 7 days', value: 'prev7', key: 'review_date_past_7_days' },
  { label: 'Past 30 days', value: 'prev30', key: 'review_date_past_30_days' },
  { label: 'Custom', value: 'custom', key: 'review_date_custom' },
]

/** translateReviews 后端单次请求上限；当前 Portal 20/50 条分页可整页提交。 */
export const TRANSLATE_BATCH_LIMIT = 100

/** 品牌分门店评分表的产品固定分页大小，同时用于约束请求类型。 */
export const SHOP_RATING_PAGE_SIZE = 10 as const

export const CUSTOM_METRICS = {
  B_APP_SHOP_EVALUATE_MERCHANTREPLY_NUM: {
    KEY: 'B_APP_SHOP_EVALUATE_MERCHANTREPLY_NUM',
  },
  B_APP_SHOP_EVALUATE_MERCHANTREPLY_SUCCESS_NUM: {
    KEY: 'B_APP_SHOP_EVALUATE_MERCHANTREPLY_SUCCESS_NUM',
  },
  B_APP_SHOP_EVALUATE_CRASH_NUM: {
    KEY: 'B_APP_SHOP_EVALUATE_CRASH_NUM',
  },

  /** 学城指标：页面加载耗时；评价管理首页或子页面完成首轮内容渲染时上报，单位 ms。 */
  B_APP_SHOP_EVALUATE_PAGE_LOAD_DURATION: {
    KEY: 'B_APP_SHOP_EVALUATE_PAGE_LOAD_DURATION',
  },

  /** 学城指标：评价列表渲染完成时间；评论请求开始至列表完成渲染，单位 ms。 */
  B_APP_SHOP_EVALUATE_LIST_RENDER_DURATION: {
    KEY: 'B_APP_SHOP_EVALUATE_LIST_RENDER_DURATION',
  },

  /** 学城指标：首屏加载完成时间（FCP/LCP）；当前采集评价列表页 LCP，单位 ms。 */
  B_APP_SHOP_EVALUATE_LCP_DURATION: {
    KEY: 'B_APP_SHOP_EVALUATE_LCP_DURATION',
  },

  /** 学城指标：图表渲染耗时；星级分布数据刷新至图表完成渲染，单位 ms。 */
  B_APP_SHOP_EVALUATE_CHART_RENDER_DURATION: {
    KEY: 'B_APP_SHOP_EVALUATE_CHART_RENDER_DURATION',
  },

  /** 学城指标：数据刷新延迟；日期范围变化至评分区域视图更新，单位 ms。 */
  B_APP_SHOP_EVALUATE_DATA_REFRESH_DURATION: {
    KEY: 'B_APP_SHOP_EVALUATE_DATA_REFRESH_DURATION',
  },

  /** 学城指标：筛选响应时间；筛选条件变化至评论列表完成刷新，单位 ms。 */
  B_APP_SHOP_EVALUATE_FILTER_RESPONSE_DURATION: {
    KEY: 'B_APP_SHOP_EVALUATE_FILTER_RESPONSE_DURATION',
  },

  /** 学城指标：卡片渲染耗时；评论请求开始至评价卡片批量完成渲染，单位 ms。 */
  B_APP_SHOP_EVALUATE_CARD_RENDER_DURATION: {
    KEY: 'B_APP_SHOP_EVALUATE_CARD_RENDER_DURATION',
  },

  /** 学城指标：分页加载时间；PC 翻页或 H5 上拉至新一页列表完成渲染，单位 ms。 */
  B_APP_SHOP_EVALUATE_PAGINATION_LOAD_DURATION: {
    KEY: 'B_APP_SHOP_EVALUATE_PAGINATION_LOAD_DURATION',
  },

  /** 学城指标：回复提交成功/失败监控；每次请求完成上报 1，以 status 区分 success/fail。 */
  B_APP_SHOP_EVALUATE_MERCHANTREPLY_RESULT_NUM: {
    KEY: 'B_APP_SHOP_EVALUATE_MERCHANTREPLY_RESULT_NUM',
  },

  /** 学城指标：回复提交响应时间；merchantReply 请求开始至响应结束，单位 ms，以 status 区分结果。 */
  B_APP_SHOP_EVALUATE_MERCHANTREPLY_DURATION: {
    KEY: 'B_APP_SHOP_EVALUATE_MERCHANTREPLY_DURATION',
  },

  /** 学城指标：回复次数超限率；提交被最大回复次数限制拦截时上报 1。 */
  B_APP_SHOP_EVALUATE_MERCHANTREPLY_LIMIT_NUM: {
    KEY: 'B_APP_SHOP_EVALUATE_MERCHANTREPLY_LIMIT_NUM',
  },

  /** 学城指标：图片上传成功率；每次申诉图片上传上报 1，以 status 区分 total/success。 */
  B_APP_SHOP_EVALUATE_APPEAL_IMAGE_UPLOAD_NUM: {
    KEY: 'B_APP_SHOP_EVALUATE_APPEAL_IMAGE_UPLOAD_NUM',
  },

  /** 学城指标：申诉提交响应时间；申诉提交请求开始至响应结束，单位 ms，以 status 区分结果。 */
  B_APP_SHOP_EVALUATE_APPEAL_SUBMIT_DURATION: {
    KEY: 'B_APP_SHOP_EVALUATE_APPEAL_SUBMIT_DURATION',
  },

  /** 学城指标：申诉列表加载耗时；请求开始至申诉列表完成渲染，单位 ms，以 status 区分结果。 */
  B_APP_SHOP_EVALUATE_APPEAL_LIST_LOAD_DURATION: {
    KEY: 'B_APP_SHOP_EVALUATE_APPEAL_LIST_LOAD_DURATION',
  },

  /** 学城指标：申诉详情加载耗时；请求开始至申诉时间线完成渲染，单位 ms，以 status 区分结果。 */
  B_APP_SHOP_EVALUATE_APPEAL_DETAIL_LOAD_DURATION: {
    KEY: 'B_APP_SHOP_EVALUATE_APPEAL_DETAIL_LOAD_DURATION',
  },

  /** 学城指标：撤销操作响应时间；撤销申诉请求开始至响应结束，单位 ms，以 status 区分结果。 */
  B_APP_SHOP_EVALUATE_APPEAL_CANCEL_DURATION: {
    KEY: 'B_APP_SHOP_EVALUATE_APPEAL_CANCEL_DURATION',
  },
}

/**
 * 申诉状态的枚举
 */
export enum IAppealStatus {
  'PROGRESS' = 0,
  'SUCCESS' = 1,
  'FAIL' = 2,
  'WITHDRAW' = 99,
}

export const bucketName = isProd(true, true) ? 'sailorfempcpublic' : 'sailorfempcpublic'
export const venusClient = isProd(true, true) ? 'pmcxkzm42l7nb2xs00000000002d62c0' : '82hkdn425qs2bxqt000000000071cbab'
export const venusClientSecret = isProd(true, true)
  ? 'eyaDx/zAsnRx8es5TZQgCc6gldaVzjdHBEy1YzjISitlueS5zedecooZJfpDRnrAvnqdnZTZzYQ0uU2FcaFvffefe1/tPIPO7FOeFT8unUxvr0QcZYEO7sOTBmQObEAg2yekrWzo3uucV1/wzaOQTjFPZ1v69rAU0nSAL/EVU2w='
  : 'q5XAuMG25KMiUIavTyKPzkjwGG5EnwIdJLrdjulPB9Zx1PUcmB1frFEK9/qtWEXAbYWo5Jverwnz3TBwLAgvSH537zKl438Q7dr5rFt3XChwYw2uEZRadtTnI2n2RFMh3uVvu9NTdZiR5Z7Z0xMzksJzSxvy7EY4OeaB+7h/4js='
export const venusEnvironment = isProd(true, true) ? 'userCenter' : 'userCenterTest'
// 直接使用后端接口 比如：`/api/scm/customer/venus/sign?bucketName=${bucketName}`
export const signatureUrlImg = `/api/scm/customer/venus/sign?bucketName=${bucketName}`
export const uploadClientId = !isProd(true, true) ? '82hkdn425qs2bxqt000000000071cbab' : 'pmcxkzm42l7nb2xs00000000002d62c0'

/**
 * 当前正在被操作申诉的评论id
 */
export const SHOP_H5_CURRENT_REVIEWID_APPEAL_BY_USER_OPERATE = 'SHOP_H5_CURRENT_REVIEWID_APPEAL_BY_USER_OPERATE'

/**
 * 是否是提交成功回来的
 */
export const SHOP_H5_IS_SUBMIT_PAGE_SUCCESS_COMEBACK_BY_USER = 'SHOP_H5_IS_SUBMIT_PAGE_SUCCESS_COMEBACK_BY_USER'